module.exports = __webpack_public_path__ + "img/a-melhor-tv-qualidade.d57d2d8b.png";